import { DateTime } from 'luxon';
import DateTimeFormat from '../const/DateTimeFormat';
import { removeMilliseconds } from './Utils';

class DateTimeUtility {
    /**
     * @param {null|string} dateTimeValue
     * @return {null|DateTime}
     */
    static parseRangeDateTimeFrom = (dateTimeValue) => {
        if (dateTimeValue === null) {
            return null;
        }
        const regex = new RegExp(`^(.*)${DateTimeFormat.DATE_TIME_REGEXP_SEPARATOR}`);
        const matches = dateTimeValue.match(regex);
        const dateTimeFromRaw = matches[1];
        if (dateTimeFromRaw === '') {
            return null;
        }
        return DateTime.fromISO(dateTimeFromRaw);
    };

    static parseRangeDateTimeTo = (dateTimeValue) => {
        if (dateTimeValue === null) {
            return null;
        }
        const regex = new RegExp(`${DateTimeFormat.DATE_TIME_REGEXP_SEPARATOR}(.*)$`);
        const matches = dateTimeValue.match(regex);
        const dateTimeToRaw = matches[1];
        if (dateTimeToRaw === '') {
            return null;
        }
        return DateTime.fromISO(dateTimeToRaw);
    };

    static generateDateTimeRangeString = (from, to) => {
        if (from === null && to === null) {
            return null;
        }
        const fromString = (from === null)
            ? ''
            : removeMilliseconds(from).toISO({ suppressMilliseconds: true });
        const toString = (to === null)
            ? ''
            : removeMilliseconds(to).toISO({ suppressMilliseconds: true });
        return fromString + DateTimeFormat.DATE_TIME_REGEXP_SEPARATOR + toString;
    };
}

export default DateTimeUtility;
